import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Layout 80 20 element, used to define 2 contentwrappers (divided 80/20)
 *
 * @slot left - used for all content on the left side (80)
 * @slot right - used for all content on the right side, aligned right(20)
 * @prop {Boolean} noPadding - Used to display the element correctly inside other elements (e.g. collapsablecard)
 * @prop {Boolean} noMargin - Set margin to 0 (optional)
 *
 */
let SDBLayout8020 = class SDBLayout8020 extends LitElement {
    constructor() {
        super(...arguments);
        this.noPadding = false;
        this.noMargin = false;
    }
    render() {
        return html `
            <div class="column80L"><slot name="left"></slot></div>
            <div class="column20R"><slot name="right"></slot></div>
        `;
    }
};
SDBLayout8020.styles = [
    elements,
    css `
            :host {
                display: grid;
                width: 100%;
                grid-template-columns: 8fr 2fr;
                grid-template-rows: auto;
                justify-self: center;
                justify-items: stretch;
                align-items: stretch;
                grid-auto-flow: row;
                gap: 20px 40px;
                margin: 20px 0;
                padding: 0 15px;
            }

            :host .column80L {
                grid-column-start: 1;
                grid-row-start: 1;
                justify-self: stretch;
            }

            :host .column20R {
                grid-column: 2;
                grid-row: 1;
                justify-self: stretch;
                display: flex;
                justify-content: end;
                align-items: center;
            }

            :host([noPadding]) {
                padding: 0;
            }

            :host([noMargin]) {
                margin: 0;
            }

            /* -------------------------------
    MOBILE LAYOUT = SAME AS LAYOUT-100
    ---------------------------------- */

            @media only screen and (max-width: 767px) {
                /* For mobile phones: */
                :host {
                    grid-template-columns: 1fr;
                }

                :host .column20R {
                    grid-column: 1;
                    grid-row: 2;
                    justify-self: stretch;
                }
            }
        `,
];
__decorate([
    property({ type: Boolean })
], SDBLayout8020.prototype, "noPadding", void 0);
__decorate([
    property({ type: Boolean })
], SDBLayout8020.prototype, "noMargin", void 0);
SDBLayout8020 = __decorate([
    customElement('sdb-layout-80-20')
], SDBLayout8020);
export { SDBLayout8020 };
//# sourceMappingURL=sdb-layout-80-20.js.map